import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { AlertService } from '../../../services/alert.service';
import { Store } from '@ngrx/store';
import { AppState, AppTypes, AppFields, StorageUtil } from '../../../store';
import * as _ from 'lodash';
import { HelperService } from '../../../services';
import { CollegeRecrutingCenterService } from '../../../services/college-recruiting-center.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-college-sideline-checkin',
  templateUrl: './college-sideline-checkin.component.html',
  styleUrls: ['./college-sideline-checkin.component.css']
})
export class CollegeSidelineCheckInComponent implements OnInit {
  public Editor = ClassicEditor;
  @Input() gameInfo;
  @Input() eventID;
  @Input() remainingGameList: any[];
  @Input() eventInfo: any;
  @Input() isDownloadHistoryAvailable: boolean;

  @Output() refreshGrid = new EventEmitter();
  @Output() openSubscriptionFlyout = new EventEmitter();
  @Output() exportGame: EventEmitter<any> = new EventEmitter();

  public isUnlockGame: boolean;
  public isUnlockMoreGames: boolean;
  public isAgreedToTerms: boolean;
  public isAgreedFreeGame: boolean;
  public isFollowedUs: boolean;
  public canDownload: boolean;
  public isSinglePlan: boolean = true;
  public coupnCode: string = "9LGiR3EE";
  planOption: any[] = [];
  origPlanOption: any[] = [];
  selectedPlanOption: any;
  sidelineCheckInDocumentPlanID: number = 1; //2;
  discountedAmount: number = 0;
  totalAmount: number = 0;
  discountCode: string;
  public NoOfSelectedGames: number = 0;
  public selectedRecordIndex = [];
  public selectedRecordList = [];

  selectedGame: any = { "description": "1 Additional Game", "amount": 15, "discountedAmount": 5 };
  @ViewChild('cardElement') cardElement: ElementRef;
  public error: string = '';
  public card: any;
  public cardHandler = this.onChange.bind(this);
  public tokenData: any;

  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() showAgreementModal: EventEmitter<boolean> = new EventEmitter();

  form: FormGroup;

  public productTypeID: number = 11;
  openedFlyout: boolean = false;
  public planList: any[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private alertService: AlertService,
    public helperService: HelperService,
    private store: Store<AppState>,
    public _service: CollegeRecrutingCenterService,
    private loader: Ng4LoadingSpinnerService,

  ) {

  }

  ngOnInit() {

    //for getting list of remaining games to unlock
    if (this.remainingGameList) {
      this.remainingGameList = this.remainingGameList.filter(x => !x.canDownload);
      this.remainingGameList.forEach(x => {
        if (x.matchID == this.gameInfo.matchID) {
          x.checked = true;
          this.NoOfSelectedGames++;
          this.selectedRecordIndex.push(x.matchID);
          this.selectedRecordList.push(x);
        }
        else {
          x.checked = false
        }
      });
    }

    if (this.isDownloadHistoryAvailable) {
      this.getSidelineCheckInDocumentPlan();
    }
    else {
      this.remainingGameList = this.remainingGameList.filter(x => x.matchID != this.gameInfo.matchID);
    }

    this.initForm();

    if (!this.card) {
      this.card = elements.create('card');
      this.card.addEventListener('change', this.cardHandler);
    }
  }

  ngAfterViewInit() {
    /*Card*/
    if (!this.card) {
      this.card = elements.create('card');
      this.card.addEventListener('change', this.cardHandler);
    }
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.onChange);
    this.card.destroy();
  }

  setLogo(url) {
    return this.helperService.setClubLogo(url);
  }

  getExportCollegeEventGamesDetails() {
    this.loader.show();
    this._service.getExportCollegeEventGamesDetails(+StorageUtil.userID, this.eventID, +StorageUtil.teamId, this.gameInfo.matchID).subscribe(
      (rs: any) => {
        this.loader.hide();
        this.canDownload = rs.canDownload;

        if (this.canDownload) {

          this.remainingGameList.forEach(x => {
            if (x.matchID == this.gameInfo.matchID) {
              x.canDownload = true;
            }
          });

          this.refreshGrid.emit();

          this.remainingGameList = this.remainingGameList.filter(x => x.canDownload == false);

          this.exportGame.emit(rs.individualTeamCollegeReport);

          this.getSidelineCheckInDocumentPlan();

          this.isUnlockGame = true;
        }
        else {
          this.isUnlockGame = false;
          this.alertService.warn(rs.reason);
          return;
        }
        console.log("rs=>", rs);
      },
      (error) => {
        this.loader.hide();
        this.alertService.error("Something went wrong.");
      }
    );
  }

  onPlanSelect(id) {
    this.selectedPlanOption = this.planOption.filter(x => x.sidelineCheckInDocumentPlanID == this.sidelineCheckInDocumentPlanID)[0];
    if (this.sidelineCheckInDocumentPlanID == 1) {
      this.isSinglePlan = true;
      if (this.NoOfSelectedGames > 0) {
        this.totalAmount = (this.selectedPlanOption.amount * this.NoOfSelectedGames);
      }
    }
    else {
      this.isSinglePlan = false;
      this.totalAmount = this.selectedPlanOption.amount;
    }
    console.log("selectedPlanOption=>", this.selectedPlanOption);
    console.log("totalAmount=>", this.totalAmount);

  }

  getSidelineCheckInDocumentPlan() {
    this.loader.show();
    this._service.getSidelineCheckInDocumentPlan().subscribe((rs: any) => {
      if (rs) {
        this.planOption = rs;
        this.origPlanOption = rs;
        this.onPlanSelect(1);
        this.loader.hide();
      }
    }, (error) => {
      this.alertService.error(error.error);
      this.loader.hide();
      console.log(error.error);
    });
  }

  agreeFreeGame(event) {
    this.isAgreedFreeGame = event.target.checked;
  }

  unlockGame(e) {
    this.getExportCollegeEventGamesDetails();
  }

  unlockGames(e) {
    this.isUnlockGame = false;
    this.isUnlockMoreGames = true;
    this.initCardNativeElement();
  }

  applyDiscountCode(event) {
    if (!this.selectedPlanOption || this.selectedPlanOption == null) {
      this.alertService.warn('Please select any plan.');
      return;
    }
    event.target.innerHTML = 'Applying <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    this._service.validateDiscountCode(this.discountCode, this.totalAmount).subscribe((rs: any) => {
      this.discountedAmount = rs;
      this.alertService.success('Discount code applied.');
      event.target.innerHTML = 'Apply Code';
      event.target.disabled = false;
    }, (error) => {
      console.log(error.error);
      event.target.innerHTML = 'Apply Code';
      event.target.disabled = false;
      this.loader.hide();
      this.alertService.error(error.error);
    });
  }

  async onAddingCard(event) {
    event.target.innerHTML = 'Adding <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    const { token, error } = await stripe.createToken(this.card);
    if (error) {
      //this.loader.hide();
      event.target.innerHTML = 'Add Card';
      event.target.disabled = false;
      if (error.code === 'card_declined' && error.type === 'card_error') {
        this.alertService.error('The credit card information is not valid');
      }
    }
    else {
      this.tokenData = token;
      console.log("tokenData=>", this.tokenData);

    }
    event.target.innerHTML = 'Add Card';
    event.target.disabled = false;
  }

  async onSubmitPayment(event) {

    event.target.innerHTML = 'Paying <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    this.loader.show();
    try {
      const { token, error } = await stripe.createToken(this.card);
      if (error) {
        //this.loader.hide();
        event.target.innerHTML = 'Add Card';
        event.target.disabled = false;
        if (error.code === 'card_declined' && error.type === 'card_error') {
          this.alertService.error('The credit card information is not valid');
        }
        this.loader.hide();
        event.target.innerHTML = 'Pay';
        event.target.disabled = false;
        return;
      }
      else {
        this.tokenData = token;
        console.log("tokenData=>", this.tokenData);
      }
    } catch (e) {
      this.loader.hide();
      event.target.innerHTML = 'Pay';
      event.target.disabled = false;
      console.error(e);
    }

    let obj = {
      UserID: +StorageUtil.userID,
      EventID: this.eventID,
      TeamID: +StorageUtil.teamId,
      MatchIDList: this.NoOfSelectedGames > 0 ? this.selectedRecordIndex : [],
      PayableAmount: (this.totalAmount - this.discountedAmount),
      DiscountAmount: this.discountedAmount,
      DiscountCode: this.discountCode,
      StripeToken: this.tokenData.id,
      StripeCardID: this.tokenData.card.id,
      CardType: this.tokenData.card.brand,
      MaskedCCNum: 'xxxx-xxxx-xxxx-' + this.tokenData.card.last4,
      ExpDate: this.tokenData.card.exp_month + '/' + this.tokenData.card.exp_year,
      SidelineCheckInDocumentPlanID: this.selectedPlanOption.sidelineCheckInDocumentPlanID
    };

    this._service.createEventTeamSideLineDocumentPaymentForTeamAccount(obj).subscribe(
      (rs: any) => {
        this.loader.hide();
        this.alertService.success("Paid successfully.");
        this.refreshGrid.emit();
        this.onClose();
      },
      (error) => {
        this.loader.hide();
        this.alertService.error(error.error);
        console.log(error.error);
      }
    );
  }

  onBack() {
    this.isUnlockGame = true;
    this.discountCode = "";
    this.planOption = this.origPlanOption;
    this.discountedAmount = 0;
    this.selectedRecordIndex = [];
    this.selectedRecordList = [];
    this.NoOfSelectedGames = 0;

    this.remainingGameList.forEach(x => {
      if (x.matchID == this.gameInfo.matchID) {
        x.checked = true;
        this.NoOfSelectedGames++;
        this.selectedRecordIndex.push(x.matchID);
        this.selectedRecordList.push(x);
        if (this.NoOfSelectedGames > 0) {
          this.totalAmount = (this.selectedPlanOption.amount * this.NoOfSelectedGames);
        }
      }
    });
    console.log("this.selectedRecordIndex==>", this.selectedRecordIndex);
    console.log("this.selectedRecordList==>", this.selectedRecordList);
    this.isUnlockMoreGames = false;
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  cardNativeElement() {
    if (this.card != null) {
      setTimeout(() => {
        this.card.mount(this.cardElement.nativeElement);
      }, 1000);
    }
  }

  initCardNativeElement() {
    //this.isAddNewCard = true;
    this.cardNativeElement();
    //this.loader.show();
    //setTimeout(() => {
    //  this.loader.hide();
    //  this.showAddNewCardButton = true;
    //}, 1500);
  }

  onAgreedToTerms(event) {
    this.isAgreedToTerms = event.target.checked;
  }

  showTermsInModal(event) {
    this.showAgreementModal.emit(event);
  }

  selectedRecord(i, e) {
    if (e.target.checked) {
      this.selectedRecordIndex.push(i.matchID);
      this.selectedRecordList.push(i);
      console.log("this.selectedRecordIndex===>", this.selectedRecordIndex);
      console.log("this.selectedRecordList===>", this.selectedRecordList);
    } else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(i.matchID), 1);
      this.selectedRecordList.splice(this.selectedRecordList.indexOf(i), 1);
      console.log("this.selectedRecordIndex===>", this.selectedRecordIndex);
      console.log("this.selectedRecordList===>", this.selectedRecordList);
    }
    this.NoOfSelectedGames = this.selectedRecordIndex.length;
    if (this.NoOfSelectedGames > 0) {
      this.totalAmount = (this.selectedPlanOption.amount * this.NoOfSelectedGames);
    }
  }

  onSocialMediaClick(socialAccount: string) {
    if (socialAccount == 'Twitter') {
      window.open("https://twitter.com/intent/follow?screen_name=totalglobalspts", "_blank");
      setTimeout(() => {
        this.isFollowedUs = true;
      }, 5000);
    } else if (socialAccount == 'Facebook') {
      window.open("https://www.facebook.com/TotalGlobalSports/", "_blank");
      setTimeout(() => {
        this.isFollowedUs = true;
      }, 5000);
    } else {
      window.open("https://www.instagram.com/tgssoccer/", "_blank");
      setTimeout(() => {
        this.isFollowedUs = true;
      }, 5000);
    }
  }

  copyCoupnCode(coupnCode) {
    const selectionBox = document.createElement('textarea');
    selectionBox.style.position = 'fixed';
    selectionBox.style.left = '0';
    selectionBox.style.top = '0';
    selectionBox.style.opacity = '0';
    selectionBox.value = String(coupnCode);
    document.body.appendChild(selectionBox);
    selectionBox.focus();
    selectionBox.select();
    document.execCommand('copy');
    document.body.removeChild(selectionBox);

    this.alertService.success("Coupn Code Copied");
  }

  shortText25(str) {
    return this.helperService.shortText25(str);
  }

  initForm() {
    this.form = this.fb.group({
      agree: [null, Validators.required],
    });
  }

  onClose(event: Event = null) {
    //event.preventDefault();
    this.close.emit(false);
    //this.resetForm();
  }

  onCancel() {
    this.cancel.emit(false);
    //this.resetForm();
  }

  get isValid(): boolean {
    if ((this.sidelineCheckInDocumentPlanID == 2) || (this.sidelineCheckInDocumentPlanID == 1 && this.NoOfSelectedGames > 0)) {
      return true;
    }
    else {
      return false;
    }
  };

  onActiveThisProduct() {
    this.openSubscriptionFlyout.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/college-sideline-checkin/college-sideline-checkin.component.ts